import { NgClass } from '@angular/common';
import { Component, HostBinding, Input, OnChanges } from '@angular/core';

import { BaseballScoreboardFactory } from '@frontend/sports/betting-offer/feature/fixture-factories';
import { BaseballStatistics, EventModel, EventScoreboard, SetGameScore } from '@frontend/sports/betting-offer/feature/model';
import { ParticipantImageComponent } from '@frontend/sports/participant-image/feature';

import { EventTimerComponent } from '../../timers/event-timer.component';
import { BaseballScoreboardLiveComponent } from './baseball-scoreboard-live.component';
import { ScoreCardComponent } from './score-card.component';
import { ScoreboardParticipantComponent } from './scoreboard-participant.component';

@Component({
    selector: 'ms-baseball-scoreboard',
    templateUrl: 'baseball-scoreboard.component.html',
    imports: [
        NgClass,
        ScoreCardComponent,
        EventTimerComponent,
        ParticipantImageComponent,
        ScoreboardParticipantComponent,
        BaseballScoreboardLiveComponent,
    ],
})
export class BaseballScoreboardComponent implements OnChanges {
    @Input() event: EventModel;
    @Input() scoreboard: EventScoreboard;
    @Input() isShowcase = false;
    @Input() showLogoColor: boolean;
    @Input() isNewEDPScoreboard = false;
    @HostBinding('class') className = 'baseball';
    score: SetGameScore;
    rotateImage: boolean[] = [];
    eventSuspended?: boolean;
    eventFinished?: boolean;
    ballsStrikesOuts: string;

    constructor(private baseballScoreboardFactory: BaseballScoreboardFactory) {}

    ngOnChanges(): void {
        this.score = this.event.scoreboard.getScore<SetGameScore>()!;

        this.event.participants.forEach((participant, index) => {
            this.rotateImage[index] = index === 1;
        });
        this.eventSuspended = this.scoreboard.period && this.scoreboard.period.id === 256;
        this.eventFinished = this.scoreboard.period && this.scoreboard.period.id === 255;
        const baseballStats = this.scoreboard.statistics as BaseballStatistics;
        this.ballsStrikesOuts = this.baseballScoreboardFactory.getBallsStrikesOuts(baseballStats, this.score);
    }
}
